"use client";

import { Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { useRouter } from "@/i18n/navigation";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FlowMapTab } from "@/components/flow/flow-map-tab";
import { FlowsList } from "./flows-list";

function FlowsPageInner() {
  const t = useTranslations("dashboard.routes");
  const router = useRouter();
  const searchParams = useSearchParams();
  const tab = searchParams.get("tab") === "map" ? "map" : "list";

  return (
    <Tabs
      value={tab}
      onValueChange={(value) =>
        router.replace(value === "map" ? "/flows?tab=map" : "/flows", {
          scroll: false,
        })
      }
      className="space-y-4"
    >
      <TabsList>
        <TabsTrigger value="list">{t("tabFlows")}</TabsTrigger>
        <TabsTrigger value="map">{t("tabMap")}</TabsTrigger>
      </TabsList>
      <TabsContent value="list">
        <FlowsList />
      </TabsContent>
      <TabsContent value="map">
        <FlowMapTab />
      </TabsContent>
    </Tabs>
  );
}

export default function FlowsPage() {
  return (
    <Suspense fallback={null}>
      <FlowsPageInner />
    </Suspense>
  );
}
